var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';
import { toYuan } from '../../utils/unit-conversion';
import chart from '../../views/balance-msg/balance-income-chart.vue';
import table from '../../components/console-common/table.vue';
import { transType as transTypeSheet, transSubType as transSubTypeSheet, } from '../../constant/common-type';
export default Vue.extend({
    name: 'balanceDetail',
    components: {
        'el-budget-list': table,
        'el-chart': chart,
    },
    data: function () {
        return {
            showTotal: false,
            totalColor: '',
            totalNum: 0,
            day: 0,
            typeText: '',
            charData: [
                {
                    type: '日扣优先',
                    value: 0.01,
                },
                {
                    type: '日扣平均',
                    value: 0,
                },
                {
                    type: '主动还款',
                    value: 0,
                },
            ],
            currentIndex: 0,
            month: '',
            dateArr: [],
            accoutSelect: '',
            settlementCompanyName: '',
            balanceType: [''],
            costTypeOptions: [],
            tabs: [
                {
                    type: '入账（元）',
                    money: 0,
                },
                {
                    type: '支出（元）',
                    money: 0,
                },
            ],
            currentTab: {},
            accoutOptions: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: 'CR',
                    label: '入账',
                },
                {
                    value: 'DR',
                    label: '支出',
                },
            ],
            income: [
                {
                    value: 'RENT',
                    label: '租金入账',
                    children: [
                        {
                            value: '',
                            label: '租金-全部',
                        },
                        {
                            value: 'DAY_AVERAGE',
                            label: '日扣平均',
                        },
                        {
                            value: 'DAY_GREED',
                            label: '日扣优先',
                        },
                        {
                            value: 'ACTIVE',
                            label: '主动还款',
                        },
                    ],
                },
                {
                    value: 'CHARGE',
                    label: '收费入账',
                    children: [
                        {
                            value: '',
                            label: '收费-全部',
                        },
                        {
                            value: 'TRAFFIC_FINE',
                            label: '违章罚款',
                        },
                        {
                            value: 'DEPOSIT',
                            label: '押金',
                        },
                        {
                            value: 'INSURE',
                            label: '保险',
                        },
                        {
                            value: 'MANAGE_FEE',
                            label: '管理费',
                        },
                        {
                            value: 'OTHER_REPAY',
                            label: '其他',
                        },
                    ],
                },
                {
                    value: 'TRANSFER_CREDIT',
                    label: '转账入账',
                },
            ],
            pay: [
                {
                    value: 'DRIVER_AWARD',
                    label: '司机补款奖励',
                    children: [
                        {
                            value: '',
                            label: '司机补款-全部',
                        },
                        {
                            value: 'AWARD',
                            label: '奖励',
                        },
                        {
                            value: 'SUBSIDY',
                            label: '补贴',
                        },
                        {
                            value: 'REFUND',
                            label: '退款',
                        },
                    ],
                },
                {
                    value: 'WITHDRAW',
                    label: '提现',
                    children: [
                        {
                            value: '',
                            label: '提现-全部',
                        },
                        {
                            value: 'WITHDRAW_FEE',
                            label: '提现手续费',
                        },
                        {
                            value: 'WITHDRAW_ARRIVAL',
                            label: '提现到账金额',
                        },
                    ],
                },
                {
                    value: 'ACTIVE_REPAY_FEE',
                    label: '主动还款手续费',
                },
                {
                    value: 'TRAFFIC_VIOLATION_QUERY_FEE',
                    label: '违章查询费',
                },
                {
                    value: 'TRANSFER_OUT',
                    label: '转账支出',
                },
                {
                    value: 'CP_RENT_DEDUCT',
                    label: '资方还款',
                },
            ],
            otherParam: {},
            requestConfig: {
                url: '/proxy/api/account/trade/tenant/page',
                method: 'post',
            },
            tableConfig: [
                {
                    label: '时间',
                    prop: 'transDate',
                    minWidth: '90px',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '交易类型',
                    prop: 'dcFlag',
                    minWidth: '120px',
                    formatter: function (val) {
                        var dict = {
                            DR: '支出',
                            CR: '收入',
                        };
                        return dict[val];
                    },
                },
                {
                    label: '费用类型',
                    prop: 'transType',
                    minWidth: '130px',
                    formatter: function (val, row) {
                        var transSubTypeCode = row.transSubType;
                        if (!transTypeSheet[val]) {
                            return '全部';
                        }
                        if (!transTypeSheet[val]['isHasSec']) {
                            return transTypeSheet[val]['name'];
                        }
                        if (!transSubTypeSheet[transSubTypeCode]) {
                            return transTypeSheet[val]['name'] + "-\u5168\u90E8";
                        }
                        return transTypeSheet[val]['name'] + "-" + transSubTypeSheet[transSubTypeCode];
                    },
                },
                {
                    label: '金额（元）',
                    prop: 'amount',
                    minWidth: '110px',
                    formatter: function (val, row) {
                        var dcFlag = row.dcFlag;
                        var amount = toYuan(val).toFixed(2);
                        return dcFlag === 'DR' ? "-" + amount : "+" + amount;
                    },
                },
            ],
            cellConfig: {
                amount: [
                    {
                        flag: 'dcFlag',
                        status: 'DR',
                        style: 'color:#FF5257',
                    },
                    {
                        flag: 'dcFlag',
                        status: 'CR',
                        style: 'color:#28AA91',
                    },
                ],
            },
            exportConfig: {
                fileName: '收支明细列表',
                keyUrl: '/proxy/api/account/trade/tenant/export',
                statusUrl: '/proxy/api/getFileUrl',
                statusKeys: 'fileGiftKey',
            },
        };
    },
    computed: __assign({}, mapState('info', {
        settleCompanyList: 'settleCompanyList',
    }), mapState('balance', {
        statistics: 'statistics',
    })),
    watch: {
        otherParam: function () {
            this.getDetailTotal();
        },
        statistics: {
            deep: true,
            handler: function () {
                this.tabMain(this.currentIndex);
            },
        },
    },
    created: function () {
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SETTLEMENT' });
        this.changeType('');
        this.$store.dispatch('balance/GET_STATISTICS', __assign({}, this.getDateRange(new Date())));
        var date = new Date();
        this.month = date.getFullYear() + "-" + (date.getMonth() + 1);
    },
    methods: {
        getDetailTotal: function () {
            var _this = this;
            var params = this.otherParam;
            this.$request({
                url: '/proxy/api/account/trade/tenant/sum',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res || res.errorCode) {
                    return;
                }
                _this.showDetailTotal(res.data);
            });
        },
        showDetailTotal: function (data) {
            var totalDay = data.totalDay, totalAmount = data.totalAmount;
            this.day = totalDay != null ? totalDay : 0;
            var _a = this.otherParam, transType = _a.transType, dcFlag = _a.dcFlag;
            var transSubTypeValue = this.otherParam.transSubType;
            if (totalAmount <= 0) {
                this.showTotal = false;
                return;
            }
            this.showTotal = true;
            var totalNum = toYuan(totalAmount).toFixed(2);
            if (dcFlag === 'DR' ||
                (transTypeSheet[transType] &&
                    transTypeSheet[transType]['identity'] === 'pay')) {
                this.totalNum = "-" + totalNum;
                this.totalColor = 'rgb(255, 82, 87)';
            }
            if (dcFlag === 'CR' ||
                (transTypeSheet[transType] &&
                    transTypeSheet[transType]['identity'] === 'income')) {
                this.totalNum = "+" + totalNum;
                this.totalColor = 'rgb(40, 170, 145)';
            }
            if (transType === '' && dcFlag === 'DR') {
                return (this.typeText = '支出-全部');
            }
            if (transType === '' && dcFlag === 'CR') {
                return (this.typeText = '收入-全部');
            }
            if (transTypeSheet[transType]) {
                if (!transTypeSheet[transType]['isHasSec']) {
                    return (this.typeText = transTypeSheet[transType]['name']);
                }
                if (transSubTypeValue === '') {
                    return (this.typeText = transTypeSheet[transType]['name'] + "-\u5168\u90E8");
                }
                return (this.typeText = transTypeSheet[transType]['name'] + "-" + transSubTypeSheet[transSubTypeValue]);
            }
            this.showTotal = false;
        },
        queryDetail: function () {
            var date = this.dateArr;
            var dateFlag = date instanceof Array && date.length > 0;
            var accoutSelect = this.accoutSelect;
            var balanceType = this.balanceType;
            var startDate = dateFlag ? moment(date[0]).format('YYYY-MM-DD') : '';
            var endDate = dateFlag ? moment(date[1]).format('YYYY-MM-DD') : '';
            var dcFlag = accoutSelect;
            var transType = balanceType[0];
            var transSubType = balanceType[1] !== undefined ? balanceType[1] : '';
            var settlementCompanyName = this.settlementCompanyName;
            this.otherParam = {
                startDate: startDate,
                endDate: endDate,
                dcFlag: dcFlag,
                transType: transType,
                transSubType: transSubType,
                settlementCompanyName: settlementCompanyName,
            };
        },
        changeType: function (val) {
            var defaultArr = [{ value: '', label: '全部' }];
            var income = val === '' || val === 'CR' ? this.income : [];
            var pay = val === '' || val === 'DR' ? this.pay : [];
            this.balanceType = [''];
            this.costTypeOptions = _.union(defaultArr, income, pay);
        },
        tabMain: function (index) {
            if (index === void 0) { index = 0; }
            this.currentIndex = index;
            var _a = this.statistics, totalIncome = _a.totalIncome, totalCost = _a.totalCost;
            this.tabs[0].money =
                totalIncome && totalIncome.value
                    ? toYuan(totalIncome.value).toFixed(2)
                    : 0;
            this.tabs[1].money =
                totalCost && totalCost.value ? toYuan(totalCost.value).toFixed(2) : 0;
            if (index === 0) {
                this.currentTab = totalIncome;
                return;
            }
            if (index === 1) {
                this.currentTab = totalCost;
            }
        },
        getMonth: function (val) {
            this.$store.dispatch('balance/GET_STATISTICS', __assign({}, this.getDateRange(val)));
        },
        getDateRange: function (date) {
            var year = date.getFullYear();
            var month = date.getMonth();
            var startDate = year + "-" + (month + 1) + "-01";
            var endDate = moment(new Date(new Date(year, month + 1).getTime() - 24 * 3600 * 1000)).format('YYYY-MM-DD');
            return {
                startDate: startDate,
                endDate: endDate,
            };
        },
        getYuan: function (val) {
            return toYuan(val).toFixed(2);
        },
        spanConfigCallback: function (row, column, rowIndex, columnIndex) {
            if (this.showTotal) {
                if (rowIndex === 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    }
                    else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            }
        },
    },
});
